// Module
var code = "<template class=\"ess-context-menu\" tabindex=\"-1\" blur.trigger=\"fireEvent('close')\" mouseup.delegate=\"element.blur()\" keydown.trigger=\"handleKeyDown($event)\" role=\"menu\"> <slot></slot> </template> ";
// Exports
module.exports = code;